
//AVCDAMOSHI.002  18/03/2025  Add code for  Add check register type page
type ApiProps = {
    url: string,
    method: "GET" | "POST" | "PUT" | "DELETE",
    headers?: HeadersInit,
    body?: BodyInit,
    query?: string,
    params?: string;
};

export const apiFetch = async (props: ApiProps) => {
    const paramFormat = props.params ? `/${props.params}` : '';
    const queryFormat = props.query ? `?${props.query}` : '';

    const configInit: RequestInit = {
        method: props.method,
        headers: props.headers,
        body: props.body,
        redirect: "follow"
    };

    try {
        const response = await fetch(`${props.url}${paramFormat}${queryFormat}`, {
            ...configInit
        });
        const result = await response.text();
        const resultJson = parseJson(result);

        if (!response.ok) {
            throw result;
        }

        return resultJson;
    } catch (error: any) {

        let errorMessage = "";
        if (typeof error === "string") {
            try {
                const parsed = JSON.parse(error);
                errorMessage = parsed?.error?.message || error;
            } catch {
                errorMessage = error;
            }
        } else if (error?.error?.message) {
            errorMessage = error.error.message;
        } else if (error?.message) {
            errorMessage = error.message;
        } else {
            errorMessage = JSON.stringify(error);
        }

        errorMessage = errorMessage.replace(/CorrelationId:.*/, "").trim();

        if (errorMessage.includes("The coupon quota is full.")) {
            throw new Error(`Quota coupon เกินกำหนด`);
        }

        if (errorMessage.includes("duplicate key error")) {
            throw new Error(`Quota coupon เกินกำหนด`);
        }
        
        if (errorMessage.includes("promotionId incorrect")) {
            throw new Error(`ขออภัยไม่สามารถใช้งานได้ในขณะนี้`);
        }

        if (errorMessage.includes("status incorrect")) {
            throw new Error(`ขออภัยไม่สามารถใช้งานได้ในขณะนี้`);
        }

        if (errorMessage.includes("use line coupon setup incorrect")) {
            throw new Error(`ขออภัยไม่สามารถใช้งานได้ในขณะนี้`);
        }

        if (errorMessage.includes("Barcode Mask is NOT correctly constructed.")) {
            throw new Error(`ขออภัยไม่สามารถใช้งานได้ในขณะนี้`);
        }

        if (errorMessage.includes("Status must be equal to 'Enabled'")) {
            throw new Error(`ขออภัยไม่สามารถใช้งานได้ในขณะนี้`);
        }

        throw new Error(errorMessage);
    }
};

function parseJson(result: string) {
    try {
        return JSON.parse(result);
    } catch (error) {
        throw new Error(`Invalid JSON format:  ${JSON.stringify(error)}`);
    }
}

//C-AVCDAMOSHI.002  18/03/2025  Add code for  Add check register type page